export const isAlwaysOnActive = (
  devicesConfiguration,
  deviceNumber,
  dockNumber
) =>
  devicesConfiguration.find(
    configuration =>
      configuration.deviceNumber === deviceNumber &&
      configuration.dockNumber === dockNumber &&
      configuration.value
  );

export default {
  isAlwaysOnActive
};
